import React from 'react';

import { Button } from 'reactstrap';

//Componentes auxiliares:
import UserCreationForm from './UserCreationForm';
import CustomModal from '../../../tools/components/CustomModal';

class UserCreationModal extends React.Component {

    constructor() {
        super();

        this.state = {
            isTheModalOpen: false,
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ textAlign: "right" }} data-tut="reactour__usersManagement.creteUserButton">
                    <Button color="info" onClick={this.modalToggle}>
                        Agregar usuario
                    </Button>
                </div>

                <CustomModal isTheModalOpen={this.state.isTheModalOpen} modalToggle={this.modalToggle}
                    size="md" title={this.getModalTitle()} footerButtons={[
                        <Button color="info" key="newUserSubmitButton" onClick={()=>{
                            try {
                                document.getElementById("newUserSubmitButton").click();
                            }
                            catch (error) { console.log(error); }
                        }}>Registrar usuario</Button>
                    ]} >

                    <UserCreationForm
                        modalToggle={this.modalToggle}
                        reloadUsersFunction={this.props.reloadUsersFunction} />

                </CustomModal>
            </React.Fragment>
        );
    }

    //Métodos operativos:
    modalToggle = () => {
        this.setState({ isTheModalOpen: !this.state.isTheModalOpen });
    }

    //Métodos de renderizado:
    getModalTitle = () => {
        return (
            <p style={{ marginBottom: 5, textTransform: "capitalize" }}>
                Nuevo
                <span style={{ textTransform: "none", marginLeft: 5 }}>
                    <b>usuario</b>
                </span>
            </p>
        );
    }

}

export default UserCreationModal;